// MyProvider.tsx
import React, { Component } from 'react';
import store from '../../../store/store';
// import * as helpers from '../helpers';
import { GENERAL } from '../config/Transaction/ProductGeneralConf';
import OrderContext from './OrderContext';
import { fetchAllOrders, getColumns } from '../reducer/orderSlice';

/**
 * @param startPage always should be 0 when it comes to 1st page since react-pagination require 1st page to be index = 0
 */

class MyProvider extends Component {
  primaryMemory = {
    status: '',
  };
  state = {
    pages: {
      startPage: GENERAL.startPage,
      endPage: 1,
      itemsperpage: GENERAL.itemsperpage,
      totalItems: 0,
    },
    userData: '',
    columns: '',
    search: '',
    userStatusData: '',
    status: '',
    appliedFilters: '',
    // sort_order: GENERAL.tableOrder.asc,
    // sort_by: GENERAL.tableSortBy,
    primaryMemory: this.primaryMemory,
  };

  prevState = [];

  setJwtToken = (jwtToken) => {
    if (jwtToken !== this.state.jwtToken) {
      this.setState({
        ...this.state,
        jwtToken,
      });
    }
  };

  setUserToken = (clientToken) => {
    if (clientToken !== this.state.clientToken) {
      this.setState({
        ...this.state,
        clientToken,
      });
    }
  };

  goBackTopreviosState = ({ ...options }) => {
    if (this.prevState.length > 0) {
      this.prevState.pop();
      const tttt = {
        ...this.prevState[this.prevState.length - 1],
      };

      // this.setState((prevState) => ({
      //   ...this.prevState[this.prevState.length - 1]
      // }));
      this.setPages({ ...options, doStorage: true });
    } else {
      // async thunk logout
    }
  };

  setSearch = ({ ...options }) => {
    const startPage = options.startPage === 0 || options.startPage ? options.startPage : this.state.pages.startPage;
    options[startPage] = startPage;

    const convState = {
      ...this.state,
      page: startPage + 1,
      pages: {
        ...this.state.pages,
        endPage: 1,
        orderCode: options.value,
      },
      orderCode: options.value,
      columns: options?.cols,
    };

    this.setState({
      ...convState,
    });

    this.makeDispatch(convState);
  };

  setSort = ({ ...options }) => {
    const convState = {
      ...this.state,
      page: 1,
      pages: {
        ...this.state.pages,
        startPage: 0,
      },
      sort_order: options.sort_order,
      sort_by: options.sort_by,
      jwtToken: options.jwtToken,
      clientToken: options.clientToken,
      columns: options?.cols,
    };

    this.setState({
      ...convState,
    });

    this.makeDispatch(convState);
  };

  setPages = async ({ ...options }) => {
    const startPage = options.startPage === 0 || options.startPage ? options.startPage : this.state.pages.startPage;
    options[startPage] = startPage;

    const convState = {
      ...this.state,
      page: startPage + 1,
      pages: {
        ...this.state.pages,
        startPage: startPage,
        endPage: 1,
        itemsperpage: this.state.pages.itemsperpage,
        orderCode: options.orderCode,
      },
    };

    this.setState({
      ...convState,
    });

    console.log('convState', convState)

    this.makeDispatch(convState);
  };

  comeToiniStateSearch = () => {
    const convState = {
      ...this.state,
      pressedVar: {
        name: null,
        state: false,
      },
      page: 1,
      pages: {
        startPage: 1,
        endPage: 1,
        itemsperpage: 20,
        totalItems: 0,
      },
      orderCode: '',
    };

    this.setState({
      ...convState,
    });

    this.makeDispatch({ ...convState });
  };

  setUserStatusState = async ({ ...options }) => {
    this.setState({
      ...this.state,
      primaryMemory: {
        ...this.state.primaryMemory,
        status: options.status,
      },
    });
  };

  removeAllStatus = async () => {
    this.setState({
      ...this.state,
      primaryMemory: {
        ...this.state.primaryMemory,
        status: '',
      },
    });
  };

  removeTagsFromFilters = (id, jwtToken, clientToken) => {
    const convState = {
      ...this.state,
      page: 1,
      clientToken,
      status: '',
      appliedFilters: '',
      primaryMemory: {
        ...this.state.primaryMemory,
        status: '',
      },
    };
    this.setState({
      ...convState,
    });

    this.makeDispatch({ ...convState, jwtToken });
  };

  statusFilterDispatcher = ({ ...options }) => {
    const convState = {
      ...this.state,
      page: 1,
      clientToken: options.clientToken,
      pages: {
        ...this.state.pages,
        startPage: 0,
      },
      appliedFilters: this.state.primaryMemory.status,
      jwtToken: options.jwtToken,
      ...this.state.primaryMemory,
      columns: options?.cols,
    };
    this.setState({
      ...convState,
    });

    this.makeDispatch(convState);
  };

  removeAllFilters = async (jwtToken, clientToken) => {
    const convState = {
      ...this.state,
      status: '',
      clientToken,
      appliedFilters: '',
      primaryMemory: {
        ...this.state.primaryMemory,
        status: '',
      },
    };

    if (this.state.appliedFilters === '') {
      return this.setState({ ...convState });
    }

    this.setState({ ...convState });
    this.makeDispatch({ ...convState, jwtToken });
  };

  setPagesIncrement = () => {
    this.setState({
      ...this.state,
      pages: {
        ...this.state.pages,
        startPage: this.state.pages.startPage + 1,
        endPage: this.state.pages.endPage + 1,
      },
    });
  };

  setPagesDecrement = () => {
    this.setState({
      ...this.state,
      pages: {
        ...this.state.pages,
        startPage: this.state.pages.startPage - 1,
        endPage: this.state.pages.endPage - 1,
      },
    });
  };

  statePusher = () => {
    this.prevState.push(this.state);
  };

  setPagesState = async ({ ...options }) => {
    this.setState({
      ...this.state,
      pages: {
        ...this.state.pages,
        startPage: options.startPage ? options.startPage : this.state.pages.startPage,
        endPage: options.endPage ? options.endPage : this.state.pages.endPage,
        itemsperpage: options.itemsperpage ? options.itemsperpage : this.state.pages.itemsperpage,
        totalItems: options.totalItems >= 0 ? options.totalItems : this.state.pages.totalItems,
      },
      jwtToken: options.jwtToken,
    });
  };

  setStatusData = async (options) => {
    const convState = {
      ...this.state,
      ...options,
      jwtToken: options?.token,
      columns: options?.cols,
    };

    await this.editStatusDispatch(options);
    await this.makeDispatch(convState);
  };

  setToggleStatus = async ({ ...options }) => {};

  

  // closeConfirmPopup = () => {
  //   return store.dispatch(closeConfirmationPopup());
  // };

  modifyUserTableCols = async ({ ...options }) => {
    return store.dispatch(getColumns(options));
  };

  makeDispatch = async ({ ...options }) => {
    console.log('options', options)
    return store.dispatch(
      fetchAllOrders({
        ...this.state,
        ...options,
      }),
    );
  };

  render() {
    const contextValue = {
      // pressedVar: this.state.pressedVar,
      pages: this.state.pages,
      search: this.state.search,
      selectLoc: this.selectLoc,
      jwtToken: this.state.jwtToken,
      userStatusData: this.state.userStatusData,
      setPages: this.setPages,
      setPagesDecrement: this.setPagesDecrement,
      setPagesIncrement: this.setPagesIncrement,
      setJwtToken: this.setJwtToken,
      goBackTopreviosState: this.goBackTopreviosState,
      prevState: this.prevStatem,
      statePusher: this.statePusher,
      setStatusData: this.setStatusData,
      setPagesState: this.setPagesState,
      setUserStatusState: this.setUserStatusState,
      status: this.state.status,
      removeUserStatusState: this.removeUserStatusState,
      modifyUserTableCols: this.modifyUserTableCols,
      setToggleStatus: this.setToggleStatus,
      openConfirmPopup: this.openConfirmPopup,
      // closeConfirmPopup: this.closeConfirmPopup,
      setUserToken: this.setUserToken,
      comeToiniStateSearch: this.comeToiniStateSearch,
      setSearch: this.setSearch,
      clientToken: this.state.clientToken,
      appliedFilters: this.state.appliedFilters,
      sort_by: this.state.sort_by,
      sort_order: this.state.sort_order,
      setSort: this.setSort,
      removeAllStatus: this.removeAllStatus,
      statusFilterDispatcher: this.statusFilterDispatcher,
      removeTagsFromFilters: this.removeTagsFromFilters,
      removeAllFilters: this.removeAllFilters,
    };

    return <OrderContext.Provider value={contextValue}>{this.props.children}</OrderContext.Provider>;
  }
}

export default MyProvider;
